export const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnQ7YcsIj5LtXFbqut/5O
oHp66l1fetQPfPPFHzOIxXjDUx2m+n8axk5+QWASO8CBjBcPMUvBUwJceYpXQbRM
ZwPYrl4gJ2aDLy8WjOkDQ3xxX6OzN6eGO4+LGWI4njM0rAMcJSoxWjNiP+NKgNX/
M9JoON/wJmpjQLxRFLDD1q2U0gpUDTMfQp1fqbbQHlWN1CQkDViDaFLq8Wn+ZHCR
Goltb2frvo5zXHbGZAM0qdSzjSiIFt14u8bHkLPCOHPtPNKv+tEmm6jqROvX13Ud
AIHdJOkbfbiRKr5xpJ57g51THdLib8KpoUMJ2K9Q+ihXGK85jgMjhfr+F68lGWh/
ewIDAQAB
-----END PUBLIC KEY-----`;
